<p-dialog
    header="Delete company"
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [style]="{ width: '28rem' }"
    [modal]="true"
    [closable]="!loading()"
>
    @if (company(); as c) {
        <div class="flex flex-col gap-4">
            <div class="flex items-center gap-3">
                <i class="pi pi-exclamation-triangle text-red-500" style="font-size: 2rem"></i>
                <span class="text-surface-700 dark:text-surface-200">
                    @if (blocked()) {
                        This company is referenced by <strong>{{ websiteCount() }}</strong> website(s) and cannot be deleted until they are reassigned.
                    } @else {
                        This action cannot be undone. The company will be soft-deleted.
                    }
                </span>
            </div>

            <div class="border border-surface-200 dark:border-surface-700 rounded p-4 flex flex-col gap-1 bg-surface-50 dark:bg-surface-800">
                <div class="text-lg font-bold">{{ c.Name }}</div>
                <div class="text-xs text-muted-color">ID: {{ c.Id }}</div>
            </div>

            @if (error()) {
                <small class="text-red-500">{{ error() }}</small>
            }
        </div>
    }
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" outlined [disabled]="loading()" (onClick)="close()" />
            <p-button
                label="Delete"
                icon="pi pi-trash"
                severity="danger"
                [loading]="loading()"
                [disabled]="blocked()"
                (onClick)="confirm()"
            />
        </div>
    </ng-template>
</p-dialog>
